import { t } from "i18next";

export const getSubscriptionIntervalKey = (
	interval?: string,
	duration?: number,
) => {
	if (interval === "month") {
		return duration === 12 ? "yearly" : "monthly";
	}
	if (interval === "week") {
		return "weekly";
	}
	return "generic";
};

export const formatPlanDuration = (
	interval: string,
	duration: number,
): string => {
	if (interval === "day") {
		const weeks = duration / 7;
		if (Number.isInteger(weeks)) {
			return t("purchase.paywall.planDuration.week", { count: weeks });
		}
	}

	if (interval === "month") {
		const years = duration / 12;
		if (Number.isInteger(years)) {
			return t("purchase.paywall.planDuration.year", { count: years });
		}
	}

	return t(`purchase.paywall.planDuration.${interval}`, {
		count: duration,
		// Intervals outside day/week/month/year have no key; fall back to the raw
		// value rather than leaking the key into the UI.
		defaultValue: `${duration} ${interval}`,
	});
};
